export default __webpack_public_path__ + "static/media/HASSAN_NL_EPILOGFIN1.68116b90.mp3";